<div class="compliance-container">
  
	<div class="compliance-container-inner">
		<img
			class="d-none d-md-block orange-pattern-overlay"
			src="../../assets/img/orange-pattern.png"
			alt=""
		/>
		<img
			class="d-md-none orange-pattern-overlay"
			src="../../assets/img/orange-pattern-mobile.png"
			alt=""
		/>
		<div class="container text-center">
			<h2 class="compliance-header">Compliance Challenges</h2>
			<p class="mb-5 compliance-sub-title">
				How RegScale Solves Common Compliance Challenges
			</p>
			<div class="compliance-challenges-img">
				<iframe
					src="https://www.youtube.com/embed/chy5caaj9sg"
					frameborder="0"
				></iframe>
			</div>

			<!-- <img
			
			src="../../assets/img/compliance-challenges.png"
			alt=""
		/> -->
			<div class="row">
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/real-time.png"
						alt=""
					/>
					<div class="challenges-list-head">Real-Time Action</div>
					<div class="challenges-list-content">
						Holistically visualize your state of compliance in real
						time vs. point in time snapshots in PowerPoint
						presentations.
					</div>
				</div>
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/up-to-date.png"
						alt=""
					/>
					<div class="challenges-list-head">Always Up-to-Date</div>
					<div class="challenges-list-content">
						Allow automation to keep your paperwork up-to-date
						with little or no manual labor via our countless
						integrations and APIs.
					</div>
				</div>
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/proactive-reactive.png"
						alt=""
					/>
					<div class="challenges-list-head">
						Proactive vs Reactive
					</div>
					<div class="challenges-list-content">
						Maintain an always ready audit posture with dashboards
						and analytics that provide actionable insights into regulatory
						compliance risks.
					</div>
				</div>
			</div>
			<a href="https://go.regscale.com/RegScale-Create-Account">
				<button class="complaince-button py-2 px-5 mt-2 mt-lg-5">
					Get Started
				</button></a
			>
		</div>
	</div>
</div>
